import { appConfig } from "../config";
import type {
  Country,
  Matchup,
  PricepoolEntry,
  Row,
  SheetData,
} from "./types";
import { parseSheetCsv } from "./parser";

let sheetDataCache: SheetData | Promise<SheetData> | undefined;

export async function fetchData(): Promise<SheetData> {
  if (sheetDataCache) {
    return sheetDataCache;
  }

  const pendingData = loadSheetData();
  sheetDataCache = pendingData;

  try {
    const data = await pendingData;
    sheetDataCache = data;
    return data;
  } catch (error) {
    sheetDataCache = undefined;
    throw error;
  }
}

async function loadSheetData(): Promise<SheetData> {
  const { sheetTabs } = appConfig;

  return {
    matchups: await fetchFromSheets<Matchup>(sheetTabs.matchups),
    countries: await fetchFromSheets<Country>(sheetTabs.countries),
    rows: await fetchFromSheets<Row>(sheetTabs.rows),
    pricepool: await fetchFromSheets<PricepoolEntry>(sheetTabs.pricepool),
  };
}

export async function fetchFromSheets<T extends SheetDataRow>(
  sheet: string,
): Promise<T[]> {
  const response = await fetch(
    `${appConfig.googleSheetsBaseUrl}&sheet=${encodeURIComponent(sheet)}`,
  );

  if (!response.ok) {
    throw new Error(`Failed to load sheet "${sheet}": ${response.status}`);
  }

  return parseSheetCsv<T>(await response.text());
}

type SheetDataRow = Matchup | Country | Row | PricepoolEntry;

export function clearDataCache(): void {
  sheetDataCache = undefined;
}
